import { FC, useContext } from "react";

import appStyles from "../../../App.module.css";
import ForwardArrow from "../../../amt/components/icons/ForwardArrow";
import { formatDate } from "../../../app-constants";
import { PortuguesePurchasePathContext } from "../../PortuguesePurchasePath";
import { IPortuguesePurchasePathContext } from "../../config/interface";
import PPFooter from "../common/PPFooter";
import PPOrderSummary from "../common/PPOrderSummary";

interface OrderDetailProps {}

const PPOrderDetail: FC<OrderDetailProps> = (props: OrderDetailProps) => {
  const { order, reset } = useContext(PortuguesePurchasePathContext) as IPortuguesePurchasePathContext;

  return (
    <div className={`${appStyles.mainContainer} ${appStyles.W600} ${appStyles.p32}`}>
      <div className={`${appStyles.quotePaymentWrapper}`}>
        <div className={`${appStyles.headerWrapper}`}>
          <div className={`${appStyles.pageTitle} ${appStyles.pageTitleCongrats}`}>
            <h1 className={`${appStyles.colorSuccess}`}>
              Congratulations! <br />
              You’re covered
            </h1>
          </div>
        </div>
        <div className={`${appStyles.pageTitle} ${appStyles.pageTitleCongrats}`}>
          <p>Check your inbox for an email with your policy documents and related information.</p>
        </div>
        <div className={`${appStyles.tripSummaryRow} ${appStyles.tripSummaryRowOrderInfo}`}>
          <div className={appStyles.tripSummaryLabel}>Order No: {order?.order_number}</div>
          <div className={appStyles.tripSummaryLabel}>Order Date: {formatDate(new Date(order?.ordered_at))}</div>
        </div>
        <PPOrderSummary />
        <div className={`${appStyles.pageSubTitle} ${appStyles.bfMarginTop}`}>
          <h3 className={appStyles.colorPrimary}>Your policy</h3>
        </div>
        <div className={`${appStyles.quoteFormBlock} ${appStyles.quoteFormPolicyInformation}`}>
          <div className={`${appStyles.tripSummaryRow}`}>
            <div className={`${appStyles.tripPolicyInfo}`}>
              <b className={`${appStyles.tripPolicyPerson}`}>
                {`${order?.applicant?.first_name || ""} ${order?.applicant?.middle_name || ""} ${
                  order?.applicant?.last_name
                }` || ""}
              </b>
              <span className={appStyles.tripSummaryLabel}>Policy #</span>
              <b>{order?.items[0]?.policy_number}</b>
            </div>
          </div>
        </div>
        <PPFooter />
        <div className={appStyles.formRow}>
          <div
            className={`${appStyles.buttonBlock} ${appStyles.buttonBlockNextPrev} ${appStyles.buttonBlockAlignCenter}`}
          >
            <button
              className={`${appStyles.bfButton} ${appStyles.bfbuttonHasIcon} ${appStyles.bfbuttonIconAfter} ${appStyles.bfButtonOutline}`}
              type="button"
              onClick={(e) => {
                reset();
              }}
            >
              New Quote
              <span className={`${appStyles.bfButtonIcon} ${appStyles.bfButtonIconNext}`}>
                <ForwardArrow />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PPOrderDetail;
